"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var Popover = function (_a) {
    var id = _a.id, onKeyDown = _a.onKeyDown, role = _a.role, disableRestoreFocus = _a.disableRestoreFocus, popoverComponent = _a.popoverComponent, anchorOrigin = _a.anchorOrigin, transformOrigin = _a.transformOrigin, popoverWrapper = _a.popoverWrapper, style = _a.style, classes = _a.classes, key = _a.key, sx = _a.sx, className = _a.className, dataTestId = _a["data-testid"], transitionDuration = _a.transitionDuration, elevation = _a.elevation, action = _a.action, anchorReference = _a.anchorReference, anchorPosition = _a.anchorPosition, container = _a.container, disableScrollLock = _a.disableScrollLock, marginThreshold = _a.marginThreshold, onClose = _a.onClose, _b = _a.slotProps, slotProps = _b === void 0 ? {} : _b, slots = _a.slots, anchorEl = _a.anchorEl, TransitionComponent = _a.TransitionComponent, TransitionProps = _a.TransitionProps, open = _a.open, children = _a.children, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"];
    var _c = __read((0, react_1.useState)(null), 2), customAnchorEl = _c[0], setAnchorEl = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), paperOpen = _d[0], setPaperOpen = _d[1];
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var popoverAnchor = (0, react_1.useRef)(null);
    var mergedSlotProps = __assign(__assign({}, slotProps), { paper: __assign({ onPointerEnter: function () { return setPaperOpen(true); }, onPointerLeave: function () { return setPaperOpen(false); } }, slotProps.paper) });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.PopoverWrapper, { ref: popoverAnchor, onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose }, popoverWrapper),
        react_1.default.createElement(styles_1.PopoverContainer, { id: id, onKeyDown: onKeyDown, role: role, disableRestoreFocus: disableRestoreFocus, open: open ? open : Boolean(customAnchorEl) || paperOpen, anchorEl: anchorEl ? anchorEl : popoverAnchor.current, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, slotProps: mergedSlotProps, anchorPosition: anchorPosition, anchorReference: anchorReference, container: container, disableScrollLock: disableScrollLock, elevation: elevation, marginThreshold: marginThreshold, onClose: onClose, slots: slots, TransitionComponent: TransitionComponent, TransitionProps: TransitionProps, transitionDuration: transitionDuration, classes: classes, sx: sx, key: key, style: style, className: className, action: action, "data-testid": dataTestId, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, popoverComponent ? popoverComponent : children)));
};
exports.default = Popover;
//# sourceMappingURL=index.js.map